import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=71971816&scoped=true&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"
import style0 from "../../static/scss/phone.scss?vue&type=style&index=0&id=71971816&scoped=true&lang=scss&"
import style1 from "./Phone.vue?vue&type=style&index=1&id=71971816&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71971816",
  null
  
)

export default component.exports